import { createSlice } from '@reduxjs/toolkit';
import { filterInitialState } from './filter-initial-state';

const engagementFilterSlice = createSlice({
  name: 'EngagementFilter',
  initialState: filterInitialState,
  reducers: {
    setSortColumn: (state, actions) => {
      state.sortColumn = actions.payload;
    },
    setSortOrder: (state, actions) => {
      state.sortOrder = actions.payload;
    },
  },
});

export const { setSortColumn, setSortOrder } = engagementFilterSlice.actions;
export default engagementFilterSlice.reducer;
